const API_URL = "https://tracker.freshmart.pe";

export async function getTrackerProducts({
    token,
    page = 1,
    limit = 20,
    signal,
}) {
    if (!token) {
        throw new Error("El token es obligatorio");
    }

    const params = new URLSearchParams({
        token,
        page: String(page),
        limit: String(limit),
    });

    const response = await fetch(
        `${API_URL}/api/dashboard/tracker-products?${params.toString()}`,
        {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
            signal,
        }
    );

    let result;

    try {
        result = await response.json();
    } catch {
        throw new Error("La respuesta del servidor no es válida");
    }

    if (!response.ok || !result.success) {
        throw new Error(
            result.message ?? "No se pudieron obtener los productos"
        );
    }

    return result;
}